<div class="flex flex-col gap-4">
  <div class="flex items-center gap-3 mb-2">
    <div class="flex items-center justify-center w-10 h-10 rounded-lg bg-primary-100 dark:bg-primary-900/30">
      <i class="pi pi-lock text-primary-600 dark:text-primary-400"></i>
    </div>
    <h3 class="font-semibold text-xl text-gray-900 dark:text-gray-100">{{ 'profile.editPassword.title' | translate }}</h3>
  </div>
  <div [formGroup]="changePasswordForm" class="flex flex-col gap-4">
    <div class="flex flex-col gap-2">
      <label for="password">{{ 'profile.editPassword.newPassword' | translate }}</label>
      <p-password id="password" formControlName="password" [feedback]="false" [placeholder]="'profile.editPassword.newPassword' | translate" toggleMask styleClass="w-full" [inputStyleClass]="'w-full'"></p-password>
      <small class="text-red-500" *ngIf="!changePasswordForm.controls['password'].valid && changePasswordForm.controls['password'].touched">{{ getPasswordError() }}</small>
    </div>
    <div class="flex flex-col gap-2">
      <label for="password2">{{ 'profile.editPassword.repeatPassword' | translate }}</label>
      <p-password id="password2" formControlName="password2" [feedback]="false" [placeholder]="'profile.editPassword.repeatPassword' | translate" toggleMask styleClass="w-full" [inputStyleClass]="'w-full'"></p-password>
      <small class="text-red-500" *ngIf="!changePasswordForm.controls['password2'].valid && changePasswordForm.controls['password2'].touched">{{ getPassword2Error() }}</small>
    </div>
    <p-button [label]="'profile.editPassword.save' | translate" (onClick)="changePassword()" [disabled]="!changePasswordForm.valid" [loading]="saving"></p-button>
  </div>
</div>
